import * as React from 'react';

import TopSection from '../../containers/HomePage/TopSection/TopSection';
import Statistics from './Statistics/Statistics';
import Reviews from './Reviews/Reviews';
import Logos from './Logos/Logos';
import Twitter from './Twitter/Twitter';
import { HomePageLocale } from './homePage.locale';

interface HomePageProps {
  locale: HomePageLocale;
}

const HomePage: React.SFC<HomePageProps> = ({ locale }) => (
  <>
    <TopSection locale={locale.topSection} />
    <div className="py-8">
      <Statistics statisticsLocale={locale.statistics} />
    </div>
    <div className="pb-6">
      <Reviews locale={locale.reviews} />
    </div>
    <Logos locale={locale.logos} />
    <Twitter locale={locale.twitter} />
  </>
);

export default HomePage;



// WEBPACK FOOTER //
// /www/client/src/components/HomePage/HomePage.tsx